/**
 * @generated SignedSource<<ac668f41d84c4d4d74fc0fccd3896b04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ContentKind = "ELearning";
import { FragmentRefs } from "relay-runtime";
export type contentConfigEditor_TreeNodeFragment$data = {
  readonly typeDefinition: {
    readonly contentKind?: ContentKind;
  };
  readonly " $fragmentSpreads": FragmentRefs<"RestartIfFailedContentConfigEditor_TreeNodeFragment" | "RestartIfPassedContentConfigEditor_TreeNodeFragment" | "flowAndCurrentElementContentConfigEditor_TreeNodeFragment" | "passContentConfigEditor_TreeNodeFragment" | "startContentConfigEditor_TreeNodeFragment">;
  readonly " $fragmentType": "contentConfigEditor_TreeNodeFragment";
};
export type contentConfigEditor_TreeNodeFragment$key = {
  readonly " $data"?: contentConfigEditor_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentConfigEditor_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentConfigEditor_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "typeDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "contentKind",
              "storageKey": null
            }
          ],
          "type": "ELearningContentTypeDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "startContentConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "passContentConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RestartIfFailedContentConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RestartIfPassedContentConfigEditor_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "flowAndCurrentElementContentConfigEditor_TreeNodeFragment"
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "8421843a1a5bcf030c1472ecf9a54e05";

export default node;
